var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4387 23.0411V25.2907C12.4387 25.4979 12.6015 25.6607 12.8087 25.6607H15.0583C15.1545 25.6607 15.2507 25.6237 15.3173 25.5497L23.3981 17.4763L20.6231 14.7013L12.5497 22.7747C12.4757 22.8487 12.4387 22.9375 12.4387 23.0411ZM25.5441 15.3303C25.8327 15.0417 25.8327 14.5755 25.5441 14.2869L23.8125 12.5553C23.5239 12.2667 23.0577 12.2667 22.7691 12.5553L21.4149 13.9095L24.1899 16.6845L25.5441 15.3303V15.3303Z",
    fill: "#FBA622"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.33998,
    y: 1.24,
    width: 35.52,
    height: 35.52,
    rx: 17.76,
    stroke: "#FBA622",
    strokeWidth: 1.48
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.46b3f17917220dda3ddc044d02ef86b2.svg";
export { ForwardRef as ReactComponent };